/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class TabApi extends runtime.BaseAPI {
    /**
     * Create Tab
     */
    async v2CreateTabRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2CreateTab().');
        }
        if (requestParameters['tabCreate'] == null) {
            throw new runtime.RequiredError('tabCreate', 'Required parameter "tabCreate" was null or undefined when calling v2CreateTab().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tabCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Tab
     */
    async v2CreateTab(requestParameters, initOverrides) {
        const response = await this.v2CreateTabRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Tab
     */
    async v2DeleteTabRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2DeleteTab().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Tab
     */
    async v2DeleteTab(requestParameters, initOverrides) {
        await this.v2DeleteTabRaw(requestParameters, initOverrides);
    }
    /**
     * Read Profile Tabs
     */
    async v2ReadProfileTabsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2ReadProfileTabs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/profile/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Profile Tabs
     */
    async v2ReadProfileTabs(requestParameters, initOverrides) {
        const response = await this.v2ReadProfileTabsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Read Tab
     */
    async v2ReadTabRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2ReadTab().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Tab
     */
    async v2ReadTab(requestParameters, initOverrides) {
        const response = await this.v2ReadTabRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Rename Tab
     */
    async v2RenameTabRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2RenameTab().');
        }
        if (requestParameters['title'] == null) {
            throw new runtime.RequiredError('title', 'Required parameter "title" was null or undefined when calling v2RenameTab().');
        }
        const queryParameters = {};
        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/{tabId}/rename`;
        urlPath = urlPath.replace(`{${"tabId"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Rename Tab
     */
    async v2RenameTab(requestParameters, initOverrides) {
        const response = await this.v2RenameTabRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Profile Sync Tab Snapshot
     */
    async v2SyncTabSnapshotRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2SyncTabSnapshot().');
        }
        if (requestParameters['tabSnapshot'] == null) {
            throw new runtime.RequiredError('tabSnapshot', 'Required parameter "tabSnapshot" was null or undefined when calling v2SyncTabSnapshot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/snapshot/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tabSnapshot'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Profile Sync Tab Snapshot
     */
    async v2SyncTabSnapshot(requestParameters, initOverrides) {
        const response = await this.v2SyncTabSnapshotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Force-delete **all** tabs belonging to the **username**. Uses `crud.profile.force_remove(...)` to physically delete each profile and its children (tabs → maps → layers) via ORM cascades.  Returns a summary of deleted IDs and any errors encountered.
     * Tabs Force Delete
     */
    async v2TabsForceDeleteUnsafeRaw(requestParameters, initOverrides) {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError('username', 'Required parameter "username" was null or undefined when calling v2TabsForceDeleteUnsafe().');
        }
        const queryParameters = {};
        if (requestParameters['username'] != null) {
            queryParameters['username'] = requestParameters['username'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/admin/force-delete`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Force-delete **all** tabs belonging to the **username**. Uses `crud.profile.force_remove(...)` to physically delete each profile and its children (tabs → maps → layers) via ORM cascades.  Returns a summary of deleted IDs and any errors encountered.
     * Tabs Force Delete
     */
    async v2TabsForceDeleteUnsafe(requestParameters, initOverrides) {
        const response = await this.v2TabsForceDeleteUnsafeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Profile Update Tab
     */
    async v2UpdateTabRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2UpdateTab().');
        }
        if (requestParameters['tabUpdate'] == null) {
            throw new runtime.RequiredError('tabUpdate', 'Required parameter "tabUpdate" was null or undefined when calling v2UpdateTab().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/tab/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tabUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Profile Update Tab
     */
    async v2UpdateTab(requestParameters, initOverrides) {
        const response = await this.v2UpdateTabRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Tab Orders
     */
    async v2UpdateTabOrdersRaw(requestParameters, initOverrides) {
        if (requestParameters['tabUpdate'] == null) {
            throw new runtime.RequiredError('tabUpdate', 'Required parameter "tabUpdate" was null or undefined when calling v2UpdateTabOrders().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tab/tabs/orders`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tabUpdate'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Update Tab Orders
     */
    async v2UpdateTabOrders(requestParameters, initOverrides) {
        const response = await this.v2UpdateTabOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
